<template>
  <div class="item-base">
    <div class="menu-left">
      <el-tree :data="MenuTree"
        node-key="id"
        :props="defaultProps"
        icon-class="el-icon-circle-plus-outline"
        @node-click="handleNodeClick"
        >
        <span slot-scope="{ node, data }" class="custom-tree-node">
          <span>{{data.menuName}}</span>
          <i class="el-icon-delete" @click="DeleteCLick(data.id)"></i>
        </span>
      </el-tree>
    </div>
    <div class="menu-right">
      <div class="item-header">
        <span v-for="(item,index) in titles" @click="currentIndex(index)" :key="index" :class="{Current: index == Index}">{{item}}</span>
      </div>
      <div class="item-body">
        <div class="look-for" v-if="Index == 0">
          <el-form label-position="left" label-width="80px">
            <el-form-item label="名称">
              <el-input disabled :placeholder="LooKId.menuName"></el-input>
            </el-form-item>
            <el-form-item label="上级分类">
              <el-input  disabled :placeholder="LooKId.superMenuName"></el-input>
            </el-form-item>
            <el-form-item label="显示排序">
              <el-input  disabled :placeholder="LooKId.showSort"></el-input>
            </el-form-item>
            <el-form-item label="创建时间">
              <el-input  disabled :placeholder="LooKId.createTime"></el-input>
            </el-form-item>
            <el-form-item label="更新时间">
              <el-input disabled :placeholder="LooKId.updateTime"></el-input>
            </el-form-item>
          </el-form>

        </div>
        <div class="change" v-if="Index == 1">
          <el-form label-position="left" label-width="80px">
            <el-form-item label="ID" >
              <el-input :placeholder="CurrentId" disabled></el-input>
            </el-form-item>
            <el-form-item label="名称">
              <el-input v-model="clist.menuName"></el-input>
            </el-form-item>
            <el-form-item label="上级分类">
              <el-select v-model="clist.superMenuId" placeholder="请选择" clearable >
                <el-tree :data="MenuTree"
                         node-key="id"
                         :props="defaultProps"
                  >
                  <div class="" slot-scope="{ node, data }" >
                    <el-option  :label="data.menuName" :value="data.id"></el-option>
                  </div>
                </el-tree>
              </el-select>
            </el-form-item>
            <el-form-item label="显示顺序">
              <el-input v-model="clist.showSort"></el-input>
            </el-form-item>
          </el-form>
          <div class="submit">
            <el-button @click="changesubmit">提交</el-button>
          </div>
        </div>
        <div class="add" v-if="Index == 2">
          <el-form label-position="left" label-width="80px">
            <el-form-item label="名称">
              <el-input v-model="alist.menuName"></el-input>
            </el-form-item>
            <el-form-item label="上级分类">
              <el-select v-model="alist.superMenuId" placeholder="请选择" clearable >
                <el-tree :data="MenuTree"
                         node-key="id"
                         :props="defaultProps"
                >
                  <div class="" slot-scope="{ node, data }" >
                    <el-option class="option" :label="data.menuName" :value="data.id"></el-option>
                  </div>
                </el-tree>
              </el-select>
            </el-form-item>
            <el-form-item label="显示顺序">
              <el-input v-model="alist.showSort"></el-input>
            </el-form-item>
          </el-form>
          <div class="submit">
            <el-button @click="addsubmit">提交</el-button>
          </div>
        </div>
        <div class="delete" v-if="Index == 3">
          <el-form label-position="left" label-width="80px">
            <el-form-item label="ID" >
              <el-input :placeholder="CurrentId" disabled></el-input>
            </el-form-item>
          </el-form>
          <div class="submit">
            <el-button @click="deletesubmit">删除</el-button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: "UserMenu",
    components: {},
    data(){
    return{
      titles:['查看','修改','添加','删除'],
      Index:0,
      clist:{},
      alist:{},
      MenuTree:[],
      LooKId:{},
      CurrentId:0,
      sublist:[],
      defaultProps:{
        children: 'childMenu',
        label: 'menuName'
      }
    }
  },
  created() {
    this.GetData()
  },
  methods:{
    DeleteCLick(id){
      // console.log(id);
      this.deletesubmit()
    },
    handleNodeClick(data,node,value){
      this.CurrentId=data.id
      this.GetCurrentData(data.id)
    },
    currentIndex(index){
      this.Index=index
    },
    GetCurrentData(id){
      this.$axios.get('/api/menu/getById',{params:{
        id: this.CurrentId,
        }}).then(res=>{
        this.LooKId=res.data.data
      })
    },
    changesubmit(){
      this.clist.id=this.CurrentId;
      this.$axios.post('/api/menu/updateMenu', this.clist).then(res=>{
        // console.log(res);
        this.GetData()
      })
    },
    addsubmit(){
      this.$axios.post('/api/menu/addMenu', this.alist).then(res=>{
        // console.log(res);
        this.GetData()
      })
    },
    deletesubmit(){
      this.$axios.delete('/api/menu/deleteById',{params:{
        id: this.CurrentId
        }}).then(res=>{
        console.log(res);
        this.GetData()
      })
    },
    GetData(){
      this.$axios.get('/api//menu/getMenuTree').then(res=>{
        // console.log(res);
        this.MenuTree=res.data.data;

      })
    },
  }
}
</script>

<style lang="less" scoped>
  .Current{
    border-bottom: 4px solid #188ACB;;
  }
  .item-base {
    background-color: #f8f8f8;
    display: flex;
    height: 95vh;
    .menu-left{
      height: 92vh;
      overflow: hidden;
      width: 170px;
      padding-top: 20px;
      background-color: #fff;
      box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1), 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
      .custom-tree-node{
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-right: 8px;
        margin: 15px 0;
      }
      .menu-first{
        img{
          width: 10px;
          height: 10px;
          border: 1px solid #CCCCCC;
          margin-top: 4px;
          margin-right: 5px;
        }
        span{
          font-size: 14px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #333333;
          line-height: 18px;
        }
        .item-css{
          height: 18px;
          display: flex;
          margin: 2px 0;
        }
        margin-left: 15px;
        .menu-second{
          margin-left: 15px;
          .menu-third{
            margin:0 15px;
            display: flex;
            justify-content: space-between;
          }
        }
      }
    }
    .menu-right{
      width: 99%;

      .item-header {
        margin: 15px 0;
        display: flex;
        span {
          display: block;
          padding-bottom: 25px;
          margin:  0 25px;
          height: 40px;
          line-height: 40px;
          font-size: 16px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #333333;
        }
      }
      .item-body {
        //margin: 30px;
        min-height: 84vh;
        margin: 10px;
        background: #FFFFFF;
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1), 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
        border-radius: 2px;

        .look-for {
          width: 600px;
          padding: 50px 0 0 50px;
        }

        .change {
          width: 600px;
          padding: 50px 0 0 50px;
        }

        .add {
          width: 600px;
          padding: 50px 0 0 50px;
        }

        .delete {
          padding: 50px 0 0 50px;
          width: 600px;
        }
      }
    }

  }
</style>